import { Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ContactUsService } from './services/contact-us.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DialogService],
})
export class AppComponent {
  get showContactUsDialog(): boolean {
    return this.contactUsService.showContactUsDialog;
  }
  
  constructor(private contactUsService: ContactUsService
  ) {}

  showDialog() {
    this.contactUsService.showContactUsDialog = true;
  }

  get showContactUsIcon() {
    return this.contactUsService.showContactUsIconInApp;
  }
}
